// Get references to the start and end date input elements

try {

  const form = document.getElementById('dateRangeFilterModal-form');

  const siteSelectInput = document.getElementById('id_site');
  const startDateInput = document.getElementById('id_start_date');
  const endDateInput = document.getElementById('id_end_date');
  
  const collapseElementList = document.querySelectorAll('.collapse')
  const dateFilterTypeInput = document.getElementById('id_date_filter');
  
  
  
  const submitButton = document.getElementById('dateRangeFilterModal-apply');
  const clearButton = document.getElementById('dateRangeFilterModal-clear');
  
  
  // Add event listeners to the input elements
  startDateInput.addEventListener('input', validateDate);
  endDateInput.addEventListener('input', validateDate);
  // clearButton.addEventListener('click', clearInputs);
  
  collapseElementList.forEach((collapseEl) => {
    collapseEl.addEventListener('show.bs.collapse', event => {
      dateFilterTypeInput.value = collapseEl.id
      dateFilterTypeInput.setAttribute('value', collapseEl.id)
      console.log("filtering by " + dateFilterTypeInput.value)
    })
  })
  console.log("filtering by " + dateFilterTypeInput.value);
  
  
  // Function to validate the date inputs
  function validateDate() {
    
    const startDate = new Date(startDateInput.value);
    const endDate = new Date(endDateInput.value);
    const today = new Date();
    today.setDate(today.getDate());  
  
    if (startDate > endDate) {
      endDateInput.value = startDateInput.value;
    }
  
    if (endDate < startDate) {
      startDateInput.value = endDateInput.value;
    }
  
    if (endDate > today) {
      endDateInput.value = today.value;
    }
  
    if (startDate > today) {
      startDateInput.value = today.value;
    }  
  }
  
  function clearInputs() {
    // reset the form values
    console.log('clearing inputs')
    siteSelectInput.selectedIndex = 0;
    startDateInput.value = '';
    endDateInput.value = '';
    // clear the query string
    // window.history.replaceState(null, null, window.location.pathname);
    // submit the form
    // console.log(submitButton);
    // form.requestSubmit();
  }

} catch (error) {
  // ignore this error on the plotly-dash page
  if (!window.location.pathname.includes('monitoring')) {
    console.error(error)
  }
}

